import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PathwaySEO from "@/components/app/PathwaySEO";
import { GUIDES } from "@/lib/guides";

function GuideRow({ guide, index }) {
  const num = String(index + 1).padStart(2, "0");
  const body = (
    <>
      <span className="font-editorial text-2xl text-stone-300 tabular-nums sm:text-3xl" aria-hidden>{num}</span>
      <div className="min-w-0 flex-1">
        <div className="text-[11px] font-underground-sc tracking-[0.16em] text-[#4C1D95]">{guide.kicker}</div>
        <h2 className="mt-1 font-editorial text-2xl leading-tight text-[#002147] sm:text-3xl">{guide.title}</h2>
        <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-stone-600">{guide.description}</p>
      </div>
      {guide.to ? (
        <ArrowRight className="mt-2 h-5 w-5 shrink-0 text-stone-300 transition-transform group-hover:translate-x-1 group-hover:text-[#4C1D95]" aria-hidden />
      ) : (
        <span className="mt-1 shrink-0 rounded-full border border-stone-300 px-2.5 py-0.5 text-[10px] font-underground-sc tracking-wider text-stone-500" data-testid={`guide-coming-soon-${guide.slug}`}>
          Coming soon
        </span>
      )}
    </>
  );
  const cls = "flex items-start gap-4 py-8 sm:gap-8 sm:py-10";
  return (
    <li className="border-t border-stone-200" data-testid={`guide-entry-${guide.slug}`}>
      {guide.to ? (
        <Link to={guide.to} data-testid={`guide-link-${guide.slug}`}
          className={`group ${cls} rounded-sm transition-colors hover:bg-white/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4C1D95] focus-visible:ring-offset-4 focus-visible:ring-offset-[#FDFBF7]`}>
          {body}
        </Link>
      ) : (
        <div className={`${cls} opacity-70`} aria-disabled="true">{body}</div>
      )}
    </li>
  );
}

export default function Guides() {
  return (
    <div className="mx-auto max-w-5xl px-5 py-14 sm:px-10 sm:py-20" data-testid="guides-page">
      <PathwaySEO
        title="Guides | WhichUniversityAdvisor"
        description="Guides and data features from WhichUniversityAdvisor: methodology and sources, flagship programmes, UK Clearing, how to apply and best-value study destinations."
        path="/guides"
      />
      <div className="text-[11px] font-underground-sc tracking-[0.18em] text-[#4C1D95]">Guides</div>
      <h1 className="mt-3 max-w-3xl font-editorial text-4xl leading-[1.05] tracking-tight text-[#002147] sm:text-5xl lg:text-6xl" data-testid="guides-heading">
        Guides to read before you choose.
      </h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-stone-600 sm:text-lg">
        Long-form guides and data features from across WhichUniversityAdvisor, each with its sources on the page.
      </p>
      <ol className="mt-14 border-b border-stone-200" data-testid="guides-list">
        {GUIDES.map((g, i) => <GuideRow key={g.slug} guide={g} index={i} />)}
      </ol>
    </div>
  );
}
